import React from 'react';
import { ArrowRight, Gift } from 'lucide-react';
import { Button } from '../ui/button';
import { finalSummary, pricingJustification, marketingImages } from '../../data/mock';

const FinalCTA = () => {
  const handlePurchase = () => {
    window.open('https://paykings.com/pay?merchant_id=wealthy_faith&amount=50', '_blank');
  };

  return (
    <section className="py-16 md:py-24 bg-gray-900 text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          {/* Header */}
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
            {finalSummary.headline}
          </h2>
          <p className="text-lg sm:text-xl text-teal-400 font-medium mb-6">
            {finalSummary.subheadline}
          </p>
          <p className="text-gray-300 text-base sm:text-lg mb-8 leading-relaxed">
            {finalSummary.description}
          </p>

          {/* Book Image */}
          <div className="flex justify-center mb-10">
            <img 
              src={marketingImages.bookCover} 
              alt="God Has A Plan Guide"
              className="w-full max-w-xs rounded-2xl shadow-2xl"
            />
          </div>

          {/* Pricing Justification */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 sm:p-8 mb-10">
            <h3 className="text-lg sm:text-xl font-bold mb-4 flex items-center justify-center gap-2">
              <Gift className="w-5 h-5 text-teal-400" />
              At $50, This Guide Costs Less Than:
            </h3>
            <div className="grid md:grid-cols-2 gap-3 sm:gap-4 text-left">
              {pricingJustification.map((item, idx) => (
                <div key={idx} className="text-gray-300 text-sm sm:text-base">
                  • {item}
                </div>
              ))}
            </div>
            <p className="text-teal-400 font-semibold mt-6 text-sm sm:text-base">
              Yet someone earning an extra $2,000/month recovers their $50 investment in less than one day.
            </p>
          </div>

          {/* CTA */}
          <Button
            onClick={handlePurchase}
            size="lg"
            className="w-full sm:w-auto bg-teal-500 hover:bg-teal-400 text-white text-base sm:text-lg md:text-xl font-bold px-6 sm:px-12 py-6 sm:py-8 rounded-xl shadow-xl group whitespace-normal"
          >
            <span className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2">
              <span>GET YOUR GUIDE - $50</span>
              <ArrowRight className="w-5 h-5 sm:w-6 sm:h-6 group-hover:translate-x-1 transition-transform" />
            </span>
          </Button>

          {/* Closing */}
          <p className="text-gray-300 mt-8 text-sm sm:text-base">
            {finalSummary.closing}
          </p>
          <p className="text-amber-400 italic mt-6 text-xs sm:text-sm">
            {finalSummary.ps}
          </p>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
